import { render, staticRenderFns } from "./ConsumerDashboard2.vue?vue&type=template&id=55dd185e&scoped=true&"
import script from "./ConsumerDashboard2.vue?vue&type=script&lang=js&"
export * from "./ConsumerDashboard2.vue?vue&type=script&lang=js&"
import style0 from "./ConsumerDashboard2.vue?vue&type=style&index=0&id=55dd185e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55dd185e",
  null
  
)

export default component.exports